type MutationListener = (agentId: string) => void;

const pendingMutations = new Map<string, number>();
const listeners = new Set<MutationListener>();

export const isManagedAgentProvisioningMutationPending = (agentId: string): boolean =>
  pendingMutations.has(agentId);

export const hasPendingManagedAgentProvisioningMutations = (): boolean => pendingMutations.size > 0;

export const subscribeManagedAgentProvisioningMutations = (listener: MutationListener): (() => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

export const beginManagedAgentProvisioningMutation = (agentId: string): (() => void) => {
  pendingMutations.set(agentId, (pendingMutations.get(agentId) ?? 0) + 1);
  for (const listener of listeners) listener(agentId);
  let settled = false;
  return () => {
    if (settled) return;
    settled = true;
    const pending = pendingMutations.get(agentId)! - 1;
    if (pending === 0) pendingMutations.delete(agentId);
    else pendingMutations.set(agentId, pending);
    for (const listener of listeners) listener(agentId);
  };
};
